import {
  SET_MIN_LEAF_COUNT,
  SET_VERIFICATION_TIER,
  SET_KEYWORD_FILTER,
  CLEAR_FILTERS,
} from "./types";

export const setMinLeafCount = (minLeafCount) => ({
  type: SET_MIN_LEAF_COUNT,
  payload: minLeafCount,
});

export const setVerificationTier = (verificationTier) => ({
  type: SET_VERIFICATION_TIER,
  payload: verificationTier,
});

export const setKeywordFilter = (keyword) => ({
  type: SET_KEYWORD_FILTER,
  payload: keyword,
});

export const clearFilters = () => ({
  type: CLEAR_FILTERS,
});
